/**
 * Página: Indústria
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Indústria',
  tagline: 'Produção segura, eficiente e rastreável.',
  description: 'Controle de ponto, EPIs e produtividade para chão de fábrica. Compliance com NR-12 e integração com sistemas de produção.',
  icon: '🏭',
  color: '#8B5CF6',
  gradient: 'linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%)',
  painPoints: [
    'Filas no relógio de ponto na troca de turno',
    'EPIs variados por setor e máquina',
    'Produtividade difícil de medir individualmente',
    'Compliance com NR-12 para máquinas',
    'Integração com sistemas de produção',
    'Controle de acesso a áreas restritas',
  ],
  benefits: [
    'Ponto facial elimina filas (ID em 1 segundo)',
    'EPI verificado por área e função',
    'Produtividade medida por estação de trabalho',
    'Integração com MES/ERP',
    'Controle de acesso por reconhecimento facial',
    'Relatórios de eficiência por turno',
  ],
  nrs: ['NR-12', 'NR-6', 'NR-10', 'NR-13', 'NR-15', 'NR-17'],
  stats: [
    { value: '-90%', label: 'Tempo de Fila' },
    { value: '+18%', label: 'OEE' },
    { value: '96%', label: 'Compliance' },
    { value: '24/7', label: 'Operação' },
  ],
  testimonial: {
    quote: 'Eliminamos 15 minutos de fila por turno. São 45 minutos/dia de produção recuperada.',
    author: 'Marcos Silva',
    role: 'Gerente Industrial',
    company: 'MetalMax Indústria',
  },
}

export default function Industria() {
  return <SegmentPage segment={segment} />
}

